import { AnnotationModelItem, CircleData, RectangleData } from '../interfaces';

export const resizeDragableOnly = function (item: AnnotationModelItem, handler: string, dx, dy) {
  const zoomRatio = window.devicePixelRatio ?? 1;
  item.data.position[0] += dx / zoomRatio;
  item.data.position[1] += dy / zoomRatio;
};

export const resizeCircle = function (item: AnnotationModelItem, handler: string, dx, dy) {
  const data: CircleData = item.data as CircleData;
  let radiusToAdd = 0;
  const dxSign = Math.sign(dx);
  const dySign = Math.sign(dy);
  if (handler == 'tl') {
    if (dxSign >= 0 && dySign >= 0) {
      radiusToAdd = -Math.hypot(dx, dy);
    } else if (dxSign <= 0 && dySign <= 0) {
      radiusToAdd = Math.hypot(dx, dy);
    }
  }

  if (handler == 'tr') {
    if (dxSign <= 0 && dySign >= 0) {
      radiusToAdd = -Math.hypot(dx, dy);
    } else if (dxSign >= 0 && dySign <= 0) {
      radiusToAdd = Math.hypot(dx, dy);
    }
  }

  if (handler == 'br') {
    if (dxSign >= 0 && dySign >= 0) {
      radiusToAdd = Math.hypot(dx, dy);
    } else if (dxSign <= 0 && dySign <= 0) {
      radiusToAdd = -Math.hypot(dx, dy);
    }
    /*if (dxSign >= 0 && dySign >= 0) {
      radiusToAdd = Math.max(dx, -dy);
    } else if (dxSign <= 0 && dySign <= 0) {
      radiusToAdd = Math.min(dx, -dy);
    }*/
  }

  if (handler == 'bl') {
    if (dxSign <= 0 && dySign >= 0) {
      radiusToAdd = Math.hypot(dx, dy);
      radiusToAdd = Math.max(dx, dy);
    } else if (dxSign >= 0 && dySign <= 0) {
      radiusToAdd = -Math.hypot(dx, dy);
    }
    /*if (dxSign <= 0 && dySign >= 0) {
      //radiusToAdd = Math.hypot(dx, dy);
      radiusToAdd = Math.max(-dx, dy);
    } else {
      //radiusToAdd = -Math.hypot(dx, dy);
      radiusToAdd = Math.min(-dx, dy);
    }*/
  }

  if (radiusToAdd > 5) {
    radiusToAdd = 5;
  }
  if (radiusToAdd < -5) {
    radiusToAdd = -5;
  }
  data.radius += radiusToAdd;

  if (data.radius < 5) {
    data.radius = 5;
  }
};

export const resizeSvg = function (item: AnnotationModelItem, handler: string, dx, dy) {
  const data: RectangleData = item.data as RectangleData;

  if (handler == 'tr') {
    data.size[0] += dx;
    data.size[1] -= dy;
    data.position[1] += dy;
  }

  if (handler == 'tl') {
    data.position[0] += dx;
    data.position[1] += dy;

    data.size[0] -= dx;
    data.size[1] -= dy;
  }
  if (handler == 'br') {
    data.size[0] += dx;
    data.size[1] += dy;
  }

  if (handler == 'bl') {
    data.position[0] += dx;

    data.size[0] -= dx;
    data.size[1] += dy;
  }
  if (data.size[0] < 5) {
    data.size[0] = 5;
  }
  if (data.size[1] < 5) {
    data.size[1] = 5;
  }
};

export const resizeRectangle = function (item: AnnotationModelItem, handler: string, dx, dy) {
  const data: RectangleData = item.data as RectangleData;
  if (handler == 'tr') {
    data.size[0] += dx;
    data.size[1] -= dy;
    data.position[1] += dy;
  }

  if (handler == 'tl') {
    data.position[0] += dx;
    data.position[1] += dy;

    data.size[0] -= dx;
    data.size[1] -= dy;
  }
  if (handler == 'br') {
    data.size[0] += dx;
    data.size[1] += dy;
  }

  if (handler == 'bl') {
    data.position[0] += dx;

    data.size[0] -= dx;
    data.size[1] += dy;
  }
  if (data.size[0] < 5) {
    data.size[0] = 5;
  }
  if (data.size[1] < 5) {
    data.size[1] = 5;
  }
};

export const resizeEllipse = function (item: AnnotationModelItem, handler: string, dx, dy) {
  const data: RectangleData = item.data as RectangleData;
  if (handler == 'tr') {
    data.size[0] += dx / 2;
    data.size[1] -= dy / 2;
    data.position[1] += dy / 2;
    data.position[0] += dx / 2;
  }

  if (handler == 'tl') {
    data.position[0] += dx / 2;
    data.position[1] += dy / 2;

    data.size[0] -= dx / 2;
    data.size[1] -= dy / 2;
  }
  if (handler == 'br') {
    data.position[0] += dx / 2;
    data.position[1] += dy / 2;
    data.size[0] += dx / 2;
    data.size[1] += dy / 2;
  }

  if (handler == 'bl') {
    data.position[0] += dx / 2;
    data.position[1] += dy / 2;

    data.size[0] -= dx / 2;
    data.size[1] += dy / 2;
  }
  if (data.size[0] < 5) {
    data.size[0] = 5;
  }
  if (data.size[1] < 5) {
    data.size[1] = 5;
  }
};
